import { useParams } from "react-router-dom";
import { useAuth } from "../../../usercontext";
import GlobalStudentLessonEdit from "../../pages/common/globalstudentlessoneditforgrade";
import STopMenu from "../topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";
import GlobalStudentLessonEdit2 from "../../pages/common/globalStudentLessonEdit2";

export default function StudentLessonsEdit() {
  const { profile } = useAuth();

  let { slug } = useParams();

  const studentId = profile.id;
  const studentClass = profile.class;
  const isStudent911 = profile?.role === "Student911";
  return (
    <>
      {!isStudent911 && <STopMenu slug={studentId} activeMenu="Lessons" />}
      {isStudent911 && <S911TopMenu slug={studentId} activeMenu="Lessons" />}
      {/* <GlobalStudentLessonEdit
        slug={slug}
        studentId={studentId}
        studentClass={studentClass}
      /> */}
      <GlobalStudentLessonEdit2
        status={slug}
        studentId={studentId}
        studentClass={studentClass}
      />
    </>
  );
}
